import { Component, ComponentRef, Type, ViewChild, effect, signal, ChangeDetectionStrategy } from '@angular/core';

import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { GenericListComponent } from '@app/common-codes/components/list-components/generic-base-list/generic-list.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { TabComponentLoader } from '@app/common-codes/services/TabComponentLoader.service';
import { ClientDetailComponent } from '../client-detail/client-detail.component';
import { ListTableColumnComponent } from '@app/common-codes/components/list-components/list-table-column/list-table-column.component';
import { ListViewComponent } from '@app/common-codes/components/list-components/list-view/list-view.component';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Client } from '@app/common-codes/models/matwins-manager/Client.model';
import { LookupProfile } from '@app/common-codes/services/LookupService';
import { TenantAccountListComponent } from '@app/components/matwins-tenant/account/account-list/account-list.component';
import { INeedRefreshData, IRefreshDateRangeValue } from '@app/common-codes/components/_primitives/INeedRefreshData';
import { StructuredDataRequest } from '@app/common-codes/_DTOs/IStructuredData';
import { IListType } from '@app/common-codes/components/_primitives/IListType';
import { ClientListComponent } from '../client-list/client-list.component';

@Register(Client)
@Component({
  selector: 'app-client-stack',
  templateUrl: './client-stack.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ListViewComponent,
    ClientDetailComponent,
    ListTableColumnComponent,
    TranslatePipe
]
})
export class ClientStackComponent extends ClientListComponent {

  public IListType = IListType; // Make IListType available in the template


  constructor(_alertModalService: AlertModalService) {
    super(_alertModalService);
    effect(() => {
      if (this.listView()?.entities()?.total === 1) {
        // this.listView()?.selectedId.set((this.listView()?.entities()?.items[0] as Client).id);
        this.listView()?.onTableEntitySelected((this.listView()?.entities()?.items[0] as Client).id);
      }
    })
  }




}
